export default __webpack_public_path__ + "static/media/Astro_Pluto_White.c238fd72.png";